import { IDefineCommand } from 'core-ts-types';
import { ORM } from 'utility-ts-orm';
import { IStudyGroupMembersDatasource } from '../datasources/study_group_members_datasource';

angular
  .module('capability-ng-study-groups')
  .factory(
    'loadStudyGroupMembersCommand',
    function loadStudyGroupMembersCommandDefinition(
      $http: ng.IHttpService,
      defineCommand: IDefineCommand,
      ngStudyGroupMembersDatasource: IStudyGroupMembersDatasource,
      log: any
    ): void {
      return defineCommand(
        'loadStudyGroupMembersCommand',
        function loadStudyGroupMembersCommand(deferred: ng.IDeferred<any>, sectionId: number): any {
          $http
            .get(`study/sections/${sectionId}/buddies`)
            .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
              ngStudyGroupMembersDatasource.clear().write(data);
              deferred.resolve(ORM.run());
            })
            .catch((response: any) => {
              log.error('Unable to get study group members data');
              deferred.reject();
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-study-groups/src/commands/load_study_group_members_command.ts